import React from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarFilterButton
} from '@mui/x-data-grid';
import { Divider, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { DebounceInput } from 'react-debounce-input';

import { useResponsive } from '../../services/hooks';
import { CssTextField } from '../others/CssTextField';
import { OrderAdvancedFilter } from './OrderAdvancedFilter';

export const DataGridToolbar = props => {
  const { onOpenSidebar, hideSidebar, miniView, searchCallback, showAll = false, advancedFilter = false } = props;
  const mdUp = useResponsive('up', 'md');

  const handle = () => {
    if (!mdUp) {
      onOpenSidebar();
    } else {
      hideSidebar();
    }
  };

  return (
    <GridToolbarContainer style={{ display: 'flex', flexWrap: 'wrap' }} >
      { miniView ? null
        : <Tooltip title="Pokaż/Ukryj menu">
          <IconButton onClick={handle} color="primary" sx={{ mr: mdUp ? 4 : 2 }}>
            <MenuIcon />
          </IconButton>
        </Tooltip>
      }
      {(miniView || showAll) && !advancedFilter
        ? <DebounceInput
          debounceTimeout={1000}
          style={{ width: 100, marginRight: 8 }}
          element={CssTextField}
          placeholder="Wyszukaj..."
          onChange={e => searchCallback(e.target.value)}
          variant="standard"
        />
        : advancedFilter
          ? <OrderAdvancedFilter searchCallback={searchCallback} />
          : null }
      {miniView ? <GridToolbarFilterButton style={{ color: '#9B231F' }} /> : null}
      <GridToolbarColumnsButton style={{ color: '#9B231F' }} />
      <GridToolbarDensitySelector style={{ color: '#9B231F' }} />
      <GridToolbarExport style={{ color: '#9B231F' }} />
    </GridToolbarContainer>
  );
};
